export { default as CurvedText } from './curvedText'



// WEBPACK FOOTER //
// ./src/components/curvedText/index.js